import { CommonUtils } from "utils";

// Validate unit name, department name and position name
export const isValidName = name => {
  const regex = /^[\p{L}0-9-_ /]{3,255}$/u;
  return name && regex.test(name) && CommonUtils.isCapitalizeFirstLetter(name);
};
